import type { GetWorklistItemQuery } from 'generated/graphql';

/**
 * The study smids sent as the HP payload's `groupedStudies`.
 *
 * The GraphQL layer forwards these as the backend's `study_ids`, which is one of three mutually
 * exclusive ways to tell the backend which case an HP belongs to (`case_id`, `study_criteria`,
 * `study_ids` — see `mapHangingProtocolPayload` in `graphql/src/resolvers/hangingProtocol.ts`). The
 * backend resolves them through `CaseRequest`, which requires that they all belong to **one** case
 * and 500s otherwise.
 *
 * So this is deliberately the current case's studies and nothing else. Priors are a different case
 * by definition, and including them (VX-4833) made every plain Update fail with "Failed to update
 * hanging protocol" whenever the radiologist had a prior open — the resolver only falls through to
 * `study_ids` when no case id and no study criteria are supplied, which is exactly the plain-Update
 * path. The HP still learns about priors through the separate `numberOfPriors` field.
 */
export const getPayloadStudyIds = (
  currentCase: Nullable<GetWorklistItemQuery['worklistItem']>
): string[] => {
  return (currentCase?.studies ?? []).map((study) => study.smid).filter((smid) => smid != null);
};
